/* eslint-disable eqeqeq */
import { BasePage } from '../../../../framework/pages/BasePage';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../framework/bar-button/BarButtonFw';
import GridFw from '../../../../framework/grid/GridFw';

export class SubparametrosResultadosEmisionModal extends BasePage {
  createPageProperties = (pageApi) => {
    return {
      title: 'Ingreso de Resultados',
    };
  }

  renderPage(pageApi) {
    const getGridParametros = () => pageApi.getComponent('parametrosGrid');
    const getGridCondicionEstandar = () => pageApi.getParentApi().getComponent('gridCondicionEstandar');
    const getGridCondicionNormal = () => pageApi.getParentApi().getComponent('gridCondicionNormal');
    const getGridOtrosParametros = () => pageApi.getParentApi().getComponent('gridOtrosParametros');

    const barHeaderConfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SAVE, onClick: async () => {
            await getGridParametros().saveItemEditing();

            getGridParametros().getData().forEach(p => {
              getGridCondicionEstandar().getData().forEach((c) => {
                if (c.id_metodo == p.id_metodo && c.id_sub_parametro == p.id_sub_parametro) {
                  getGridCondicionEstandar().updateItem({
                    ...c,
                    resultado_1: parseFloat(p?.hora_uno * p?.condicion_estandar).toFixed(2),
                    resultado_2: parseFloat(p?.hora_dos * p?.condicion_estandar).toFixed(2),
                    resultado_3: parseFloat(p?.hora_tres * p?.condicion_estandar).toFixed(2)
                  });
                }
              });
            });
            getGridCondicionEstandar().refresh();

            getGridParametros().getData().forEach(p => {
              if (p.id_rel_metodo_param_equivalencia == p.id_rel_metodo_param) {
                getGridOtrosParametros().getData().forEach((c) => {
                  if (c.id_rel_metodo_param == p.id_rel_metodo_param) {
                    getGridOtrosParametros().updateItem({
                      ...c,
                      resultado_1: parseFloat(p?.hora_uno).toFixed(2),
                      resultado_2: parseFloat(p?.hora_dos).toFixed(2),
                      resultado_3: parseFloat(p?.hora_tres).toFixed(2)
                    });
                  }
                });
              }
            });
            getGridOtrosParametros().refresh();

            getGridCondicionEstandar().getData().forEach(e => {
              getGridCondicionNormal().getData().forEach((n) => {
                if (n.id_rel_metodo_param_equivalencia == e.id_rel_metodo_param && n.id_rel_metodo_param == e.id_rel_metodo_param_equivalencia) {
                  getGridCondicionNormal().updateItem({
                    ...n,
                    resultado_1: e?.resultado_1 == undefined ? 0 : parseFloat((e?.resultado_1 * 298) / 273).toFixed(2),
                    resultado_2: e?.resultado_2 == undefined ? 0 : parseFloat((e?.resultado_2 * 298) / 273).toFixed(2),
                    resultado_3: e?.resultado_3 == undefined ? 0 : parseFloat((e?.resultado_3 * 298) / 273).toFixed(2)
                  });
                }
              });
            });
            getGridCondicionNormal().refresh();

            getGridParametros().save();
          }
        },
        { ...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal() }
      ]
    }

    const gridConfig = {
      rowId: 'id_cadena_subparametro',
      showIndex: false,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      load: {
        queryId: 946,
        params: () => {
          return {
            id_parametro: pageApi?.name?.data.id_parametro
          }
        }
      },
      save: {
        queryId: 927,
      },
      fields: [
        { name: 'sub_parametro', label: 'Sub Parámetro' },
        {
          type: 'select', name: 'um_id', label: 'Unidad Medida', labelName: 'desUM', column: 4, search: true, editable: true, load: {
            queryId: 583, params: () => {
              return {
                id_metodo: getGridParametros().itemEditing.id_metodo,
              }
            }
          }
        },
        { name: 'hora_autozero', label: 'Autozero', editable: true },
        { name: 'hora_uno', label: '1', editable: true },
        { name: 'hora_dos', label: '2', editable: true },
        { name: 'hora_tres', label: '3', editable: true },
      ]
    };

    return (
      <>
        <GridFw
          name="parametrosGrid"
          getParentApi={pageApi.getApi}
          config={gridConfig}
        />
        <BarButtonFw
          name="agregarButton"
          getParentApi={pageApi.getApi}
          config={barHeaderConfig}
        />
      </>
    )
  }
}
